import { Component, OnInit, Inject } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AccountingAccountsModel } from './accounting-accounts.model';
import { AccountingAccountsService } from './accounting-accounts.service';
import { AccountingAccountsListComponent } from './accounting-accounts-list.component';
import { CoreComponent } from '../../../core/header/core.component';
import { DummyComponent } from '../../../shared/dummy.component';

@Component({
    selector: 'convfact-accountingAccounts',
    templateUrl: './accounting-accounts.component.html',
    styleUrls: ['./accounting-accounts.component.css'],
    standalone: false
})
export class AccountingAccountsComponent implements OnInit {
  public accountingAccounts = new AccountingAccountsModel();
  public errors = {};
  public uid: string = this.data.uid;
  public ready = false;

  constructor(
    public dialogRef: MatDialogRef<AccountingAccountsListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private accountingAccountsService: AccountingAccountsService,
    public snackBar: MatSnackBar,
    private core: CoreComponent,
    private dummy: DummyComponent
  ) {}

  submit(): void {}

  public saveData(accountingModel: AccountingAccountsModel): void {
    if (accountingModel.uid == null) {
      this.accountingAccountsService.create(accountingModel)
        .then(response => {
          this.core.refresh();
          this.returnToIndex();
          this.dialogRef.close();
          this.displayInfo(response);
        })
        .catch(error => {
          this.displayInfo(error['error']['message']);
        });
    } else {
      this.accountingAccountsService.edit(accountingModel.uid, accountingModel)
        .then(response => {
          this.displayInfo('Cuenta contable modificada con éxito');
          this.core.refresh();
          this.returnToIndex();
          this.dialogRef.close();
          this.displayInfo(response);
        })
        .catch(error => {
          this.displayInfo(error['error']['message']);
        });
    }
  }

  ngOnInit(): void {
    if (this.uid != null) {
      this.accountingAccountsService.get(this.uid).then(response => {
        this.accountingAccounts = response;
        this.ready = true;
      });
    } else {
      this.ready = true;
    }
  }

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container'];
    this.snackBar.open(message, '', options);
  }

  returnToIndex = (): void => {
    this.dummy.redirectTo('/accounting/accounts');
  };
}